import {
    ANALYTICS_NAME as CLAIM_ACCOUNT_ANALYTICS_NAME,
    PATH_NAME as CLAIM_ACCOUNT_PAGE_NAME,
    TITLE as CLAIM_ACCOUNT_TITLE,
    PAGE_TYPE as CLAIM_ACCOUNT_PAGE_TYPE,
    ROLLUP_BUCKET as CLAIM_ACCOUNT_ROLLUP_BUCKET,
} from '../claimAccount/constants';
import {
    ANALYTICS_NAME as REGISTER_ANALYTICS_NAME,
    PAGE_NAME as REGISTER_PAGE_NAME,
    TITLE as REGISTER_TITLE,
    PAGE_TYPE as REGISTER_PAGE_TYPE,
    ROLLUP_BUCKET as REGISTER_ROLLUP_BUCKET,
} from '../createUser/constants';
import {
    ANALYTICS_NAME as RESET_PASSWORD_ANALYTICS_NAME,
    PAGE_NAME as RESTER_PASSWORD_PAGE_NAME,
    TITLE as RESET_PASSWORD_TITLE,
    PAGE_TYPE as RESET_PASSWORD_PAGE_TYPE,
    ROLLUP_BUCKET as RESET_PASSWORD_ROLLUP_BUCKET,
} from '../resetPassword/constants';
import {
    ANALYTICS_NAME as SIGN_IN_ANALYTICS_NAME,
    PAGE_NAME as SIGN_IN_PAGE_NAME,
    TITLE as SIGN_IN_TITLE,
    PAGE_TYPE as SIGN_IN_PAGE_TYPE,
    ROLLUP_BUCKET,
} from '../signin/constants';

export const getAnalyticsMeta = (pathName) => {
    const pageName = pathName.split('/')[1].toLowerCase();

    switch (pageName) {
        case SIGN_IN_PAGE_NAME:
            return [
                SIGN_IN_ANALYTICS_NAME,
                SIGN_IN_TITLE,
                SIGN_IN_PAGE_TYPE,
                ROLLUP_BUCKET,
            ];

        case REGISTER_PAGE_NAME:
            return [
                REGISTER_ANALYTICS_NAME,
                REGISTER_TITLE,
                REGISTER_PAGE_TYPE,
                REGISTER_ROLLUP_BUCKET,
            ];

        case CLAIM_ACCOUNT_PAGE_NAME:
            return [
                CLAIM_ACCOUNT_ANALYTICS_NAME,
                CLAIM_ACCOUNT_TITLE,
                CLAIM_ACCOUNT_PAGE_TYPE,
                CLAIM_ACCOUNT_ROLLUP_BUCKET,
            ];

        case RESTER_PASSWORD_PAGE_NAME:
            return [
                RESET_PASSWORD_ANALYTICS_NAME,
                RESET_PASSWORD_TITLE,
                RESET_PASSWORD_PAGE_TYPE,
                RESET_PASSWORD_ROLLUP_BUCKET,
            ];

        default:
            return {};
    }
};
